import { getColumnKey } from "slices/settings/shreddingTemplateDraftLayout";
import { getNameError as findNameError } from "utils/nameUniqueness";
import { CORE_COLUMN_NAMES } from "utils/shreddingTemplate/coreColumns";

export { normalizeName } from "utils/nameUniqueness";

export const SHREDDING_TEMPLATE_ERROR_CODES = {
  duplicateName: "DUPLICATE_NAME",
  templateLocked: "TEMPLATE_LOCKED",
  invalidTemplateFile: "INVALID_TEMPLATE_FILE",
  invalidLayout: "INVALID_LAYOUT",
  lastTemplateNotDeletable: "LAST_TEMPLATE_NOT_DELETABLE",
};

export const DUPLICATE_NAME_ERROR =
  "A shred template with this name already exists.";

export const DUPLICATE_COLUMN_NAME_ERROR =
  "A column with this name is already used in this template.";

export const DUPLICATE_VALUE_ERROR =
  "This value already exists in this column.";

export const getNameError = (name, templates = []) =>
  findNameError(
    name,
    templates.map((template) => template.name),
    DUPLICATE_NAME_ERROR
  );

export const getColumnNameError = (name, columns = [], excludeKey = null) =>
  findNameError(
    name,
    [
      ...CORE_COLUMN_NAMES,
      ...columns
        .filter(
          (column) => excludeKey == null || getColumnKey(column) !== excludeKey
        )
        .map((column) => column.name),
    ],
    DUPLICATE_COLUMN_NAME_ERROR
  );
